<template>
    <div id="macy-container" class="horizontal-masonry">
        <div class="masonry-item" v-for="(item, index) in allImages" :key="index">
            <div v-if="index == 1" class="masonry-item-inner" :macy-complete="1">    
                <img    
                    :src="$url+'/'+item.featured" 
                    @click="show(item)" 
                    :alt="item.title"
                />
            </div>    
            <div v-else class="masonry-item-inner" >        
                <img    
                    :src="$url+'/'+item.featured" 
                    @click="show(item)" 
                    :alt="item.title"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Macy from 'macy'

export default {
    name: 'HorizontalMasonryComponent',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            macy: null
        }
    },
    mounted() {
        this.initMacy()
    },
    computed: {
        allImages() {
            if (!this.items) return []
            
            // Handle the same data structure as the original Masonry component
            if (this.items.all && Array.isArray(this.items.all)) {
                return this.items.all
            }
            
            // If it's already an array, use it directly
            if (Array.isArray(this.items)) {
                return this.items
            }
            
            // If it's an object with col1, col2, col3, combine them
            if (this.items.col1 || this.items.col2 || this.items.col3) {
                const all = []
                if (this.items.col1) all.push(...this.items.col1)
                if (this.items.col2) all.push(...this.items.col2)
                if (this.items.col3) all.push(...this.items.col3)
                return all
            }
            
            return []
        }
    },
    methods: {
        show(item) {
            this.$emit('show-image', item)
        },
        initMacy() {
            this.macy = Macy({
                container: '#macy-container',
                trueOrder: false,
                waitForImages: false,
                debug: true,
                columns: 4,
                margin: {
                    y: 16,
                    x: '2%',
                },
                breakAt: {
                    1200: 4, 
                    940: 3,
                    520: 2,
                    400: 1
                }
            })
        }
    }
}
</script>
